module.exports = __webpack_public_path__ + "static/media/albumArt.5f2fbfb1.jpg";